var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcPrint(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 6C9 5.44772 9.44772 5 10 5H18C18.5523 5 19 5.44772 19 6V9.5H9V6Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 12C5 11.4477 5.44772 11 6 11H22C22.5523 11 23 11.4477 23 12V19C23 19.5523 22.5523 20 22 20H19.5V16.5C19.5 15.9477 19.0523 15.5 18.5 15.5H9.5C8.94772 15.5 8.5 15.9477 8.5 16.5V20H6C5.44772 20 5 19.5523 5 19V12ZM19 12.375C18.6548 12.375 18.375 12.6548 18.375 13C18.375 13.3452 18.6548 13.625 19 13.625L20.5 13.625C20.8452 13.625 21.125 13.3452 21.125 13C21.125 12.6548 20.8452 12.375 20.5 12.375L19 12.375Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18 22C18 22.5523 17.5523 23 17 23L11 23C10.4477 23 10 22.5523 10 22L10 17L18 17L18 22Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPrint);
export default __webpack_public_path__ + "static/media/ic-print.f92242c6c44d8f384e3e3d957cd2615c.svg";
export { ForwardRef as ReactComponent };